import { format } from 'date-fns/format';
import { parseISO } from 'date-fns/parseISO';
function getContextualAriaLabel(_a) {
  var ariaLabel = _a.ariaLabel,
    endDate = _a.endDate,
    isDateFocusable = _a.isDateFocusable,
    price = _a.price,
    startDate = _a.startDate;
  // Only the Day that can be focused needs the verbose label because it's the only one that
  // will be read by screen readers.
  if (!isDateFocusable) {
    return ariaLabel;
  }
  var readableStart = startDate ? format(parseISO(startDate.toString()), 'PP') : '';
  var readableEnd = endDate ? format(parseISO(endDate.toString()), 'PP') : '';
  var departStr = startDate ? "Depart ".concat(readableStart) : '';
  var returnStr = endDate ? "Return ".concat(readableEnd) : '';
  var priceStr = price ? ". Price $".concat(price) : '';
  var endDateLabel = "".concat(departStr).concat(returnStr ? ", ".concat(returnStr) : '');
  return endDateLabel ? "".concat(endDateLabel).concat(priceStr, ". Use arrow keys to change.") : ariaLabel;
}
export default getContextualAriaLabel;